import {connect} from 'react-redux';
import React, {Component} from 'react';
import ReactModal from 'react-modal';
import {BASE_URL} from "../../constants/Api";

class ExportCalendarModal extends Component {
    constructor(props) {
        super(props);
    }

    onClose(event) {
        event.preventDefault();

        this.props.onClose();
    }

    copyLink(e) {
        e.preventDefault();

        this.url.select();
        document.execCommand("copy");
        this.url.blur()
    }

    render() {
        let {i18n, objectId} = this.props;

        return (
            <ReactModal
                className="custom-react-modal external-calendars-modal"
                isOpen={this.props.isOpen}
                overlayClassName="custom-react-modal-overlay"
            >
                <form className="light">
                    <div className="external-calendars-modal_close">
                        <i className="fa fa-close" onClick={::this.onClose}/>
                    </div>
                    <div className="external-calendars-modal_title">
                        {i18n['creatingObjectPage.theCalendar.exportCalendar.title']}
                    </div>

                    <div className="external-calendars-modal_form">
                        <label>
                            {i18n['creatingObjectPage.theCalendar.exportCalendar.link']}:
                            <input
                                value={BASE_URL + "/property/" + objectId + "/ical"}
                                ref={input => {
                                    this.url = input;
                                }}
                            />
                        </label>
                    </div>

                    <br/>
                    <button className="btn" onClick={::this.copyLink}>
                        {i18n['creatingObjectPage.theCalendar.exportCalendar.copy']}
                    </button>
                </form>
            </ReactModal>
        );
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    objectId: state.creatingObjectPage.createdObject.id,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ExportCalendarModal);


// WEBPACK FOOTER //
// ./src/components/CreatingProperty/ExportCalendarModal.js